<template>
	<BaseModal
		:visible="visible"
		:title="$t('create_n', { name: $t('ticket') })"
		size="xl"
		:button-name="$t(props.data?.id ? 'save' : 'add')"
		:loading="state.loading"
		@close="emit('close')"
		@button-click="submit"
	>
		<div class="flex flex-col items-center p-6">
			<div class="grid w-full grid-cols-1 gap-6">
				<BaseTextInput
					type="select"
					theme-type="outlined"
					:placeholder="$t('priority')"
					:value="data?.priority"
					:options="priorities"
					option-name="name"
					option-value="value"
					@change="(v) => emit('update:data', { ...data, priority: v } as DevTicket)"
				/>
				<BaseTextInput
					theme-type="outlined"
					:value="props.data?.title"
					:placeholder="$t('title')"
					@change="(v) => emit('update:data', { ...data, title: v } as DevTicket)"
				/>
			</div>
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import type { DevTicket } from "~/models/dev-ticket"

const devTicketStore = useDevTicketStore()
const { $toast, $i18n, $toastErrors } = useNuxtApp()

const emit = defineEmits<{
	"update:data": [DevTicket]
	done: [DevTicket]
	close: []
}>()

const props = defineProps<{
	visible: boolean
	data: DevTicket | null
}>()

const state = reactive({
	loading: false
})

const priorities = computed(() => devTicketStore.priorities)

const submit = async () => {
	state.loading = true
	try {
		const ticket = await devTicketStore.createDevTicket({
			title: props.data?.title!,
			priority: props.data?.priority!
		})
		$toast.success({
			message: $i18n.t("n_created", {
				name: $i18n.t("ticket")
			})
		})
		emit("done", ticket)
		emit("close")
	} catch (e) {
		$toastErrors(e)
	}
	state.loading = false
}
</script>

<style scoped></style>
